"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _configs = require("./configs");
Object.keys(_configs).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _configs[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _configs[key];
    }
  });
});